export default function errorView() {
    return "\n  <div class=\"error-view\">\n    <h1>Error 404</h1>\n    <h2>This view does not exist</h2>\n  </div>\n  ";
}
